export const CREATE_APPT_CONFIG_QUERY_KEY = "createApptConfig";
